import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { navItems } from './sidebar-data';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { CommonModule } from '@angular/common';
import { LocalizationService } from '../../../../services/localizationService';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-horizontal-sidebar',
    imports: [AppHorizontalNavItemComponent, CommonModule, MatButtonModule],
    templateUrl: './sidebar.component.html',
    styles: [`
      .language-buttons {
        display: flex;
        gap: 4px;
      }
      .language-buttons button {
        min-width: 40px;
        padding: 0 8px;
      }
      .language-buttons button.active {
        background-color: rgba(0, 0, 0, 0.08);
        font-weight: bold;
      }
    `]
})
export class AppHorizontalSidebarComponent implements OnInit {
  navItems = navItems;
  parentActive = '';
  currentLang: string;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    public navService: NavService,
    public router: Router,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private localizationService: LocalizationService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe(
      () => (this.parentActive = this.router.url.split('/')[1])
    );
    this.currentLang = this.localizationService.activeLanguage;
  }

  ngOnInit(): void {
    this.localizationService.currentLang.subscribe(lang => {
      this.currentLang = lang;
    });
  }
  
  changeLanguage(lang: string): void {
    this.localizationService.setCurrentLang(lang);
  }
}
